import styled from 'styled-components';

export const Content = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  height: 84vh;
  padding: 40px 30px;

  color: ${(props) => props.theme.color.text.primary};
  text-align: justify;
  p {
    b {
      font-weight: ${(props) => props.theme.font.body.weight.bold};
    }
  }

  h3 {
    font-weight: ${(props) => props.theme.font.title.weight.bold};
  }

  ul {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.regular};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  }

  @media only screen and (max-width: 768px) {
    padding: 20px 30px;
  }
`;

export const LeftParagraph = styled.div`
  margin-left: 400px;
  p {
    /* line-height: 20px; */
    margin: 0;
    font-style: italic;
  }
`;
